jQuery(document).ready(function ($){

    /* Search toggle */
    $( document ).on( 'click', '.search-toggle', function(){
        $('.header-search').fadeToggle(300);
    });

    /* Header search */
    $( document ).on( 'input', '.head-search', function(e){
        var txt = $(this).val();
        if (e.keyCode == 13) {
            return false;
        }
        if(txt.length >= 3) {
            $('.head-search').parent().addClass('processing');
            $.ajax({
                url : "/wp-admin/admin-ajax.php",
                method : "post",
                data : {
                    action: 'search_site',
                    search: txt
                },
                success: function( data ) {
                    $('.head-search').parent().removeClass('processing');
                    $('.header-search .search-results').html(data);
                }
            });
        } else {
            $('.head-search').parent().removeClass('processing');
            $('.header-search .search-results').html('');
        }
    });

    /* Hiking planer search */
    $( document ).on( 'input', '.hiking-planner-search', function(e){
        var txt = $(this).val();
        if (e.keyCode == 13) {
            return false;
        }
        if(txt.length >= 3) {
            $('.hiking-planner-search').parent().addClass('processing');
            $.ajax({
                url : "/wp-admin/admin-ajax.php",
                method : "post",
                data : {
                    action: 'search_hikings',
                    search: txt
                },
                success: function( data ) {
                    $('.hiking-planner-search').parent().removeClass('processing');
                    $('.hiking-planner-search-wrapper .search-results').html(data);
                }
            });
        } else {
            $('.hiking-planner-search').parent().removeClass('processing');
            $('.hiking-planner-search-wrapper .search-results').html('');
        }
    });

    $(('body')).on('click',function(e) {
        if ($(e.target).hasClass('search-results')) {
            return false;
        }
        $('.search-results li').hide();
    })

});